import React, { useState, useEffect } from "react";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import "./Navbar.css";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav className={`navbar navbar-expand-lg fixed-top ${isScrolled ? "navbar-scrolled" : "navbar-transparent"}`}>
      <div className="container">
        
        {/* Logo Section */}
        <a className="navbar-brand" href="/">
          <img 
            src="/logo.jpeg" 
            alt="Gau Bliss Logo"
            className="logo_header"
          />
        </a>

        {/* Toggler for Mobile */}
        <button
          className="navbar-toggler shadow-none border-0"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#mobileNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navigation Links */}
        <div className="offcanvas offcanvas-end custom-offcanvas" id="mobileNav" tabIndex="-1">
          <div className="offcanvas-header border-bottom border-secondary">
            <h5 className="offcanvas-title text-gold">MENU</h5>
            <button type="button" className="btn-close btn-close-white" data-bs-dismiss="offcanvas"></button>
          </div>
          
          <div className="offcanvas-body">
            <ul className="navbar-nav mx-auto">
              <li className="nav-item"><a className="nav-link" href="#home">Home</a></li>
              <li className="nav-item"><a className="nav-link" href="#about">About Us</a></li>
              <li className="nav-item"><a className="nav-link" href="#product">Product</a></li>
              <li className="nav-item"><a className="nav-link" href="#whychooseus">Why Choose Us</a></li>
              <li className="nav-item"><a className="nav-link" href="#gallery">Gallery</a></li>
            </ul>

            {/* Mobile Contact Info (Inside Menu) */}
            <div className="d-lg-none mt-4 pt-3 border-top border-secondary">
              <p className="small text-secondary mb-2">GET IN TOUCH</p>
              <a href="tel:+919811145511" className="d-block text-white text-decoration-none mb-2">
                <FaPhoneAlt className="text-gold me-2" /> +91 9811145511
              </a>
              <a href="mailto:contact@gaubliiss.com" className="d-block text-white text-decoration-none">
                <FaEnvelope className="text-gold me-2" /> contact@gaubliiss.com
              </a>
            </div>
          </div>
        </div>

        {/* Desktop Contact Info */}
        <div className="d-none d-lg-flex align-items-center contact-desktop">
          <a href="tel:+919811145511" className="nav-info-link me-4">
            <FaPhoneAlt className="text-gold me-2" /> +91 9811145511
          </a>
          <a href="mailto:contact@gaubliiss.com" className="nav-info-link">
            <FaEnvelope className="text-gold me-2" /> contact@gaubliiss.com
          </a>
        </div>

      </div>
    </nav>
  );
};

export default Navbar;